import React from 'react'
import { TbFileTypeXls } from 'react-icons/tb'

import { Button } from './legacy'
function ButtonExportExcel({ onClick }) {
  return (
    <Button onClick={onClick} variant={'outline'}>
      <TbFileTypeXls />
      <span className="pl-1 font-bold">Xuất Excel</span>
    </Button>
  )
}

export default ButtonExportExcel
